import { Contact, Currency, ImageCachePaths, Locale } from '@synergy/models';
import { createReducer } from '@reduxjs/toolkit';
import { defaultLocale } from '@synergy/config';

import { Account } from '../models/account';
import { FooterDto } from '../models/dto/footer-dto';
import { Header } from '../models/header';
import { User } from '../models/user';
import { applicationConfigLoaded } from './configuration-actions';

export interface ConfigurationState {
    currentLocale: Locale;
    supportedLocales: Locale[];
    currency: Currency;
    supportedCurrencies: Currency[];
    user: User;
    imageCachePaths?: ImageCachePaths;
    productImagePaths?: ImageCachePaths;
    account?: Account;
    accounts: Account[];
    header?: Header;
    footer?: FooterDto;
    privateFilesystemPath: string;
    mediaBaseUrl?: string;
    shopAdmins: Contact[];
    isImpersonator?: boolean | null;
    isPoolAccount?: boolean | null;
}

const initialState: ConfigurationState = {
    currentLocale: defaultLocale,
    supportedLocales: [defaultLocale],
    currency: Currency.EUR,
    supportedCurrencies: [Currency.EUR],
    accounts: [],
    header: undefined,
    footer: undefined,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    user: undefined!,
    privateFilesystemPath: '/synergy/api/files',
    shopAdmins: [],
    isImpersonator: false,
    isPoolAccount: false,
};

export const configurationReducer = createReducer(initialState, builder => {
    builder.addCase(applicationConfigLoaded, (state, action) => ({
        ...state,
        currentLocale: action.payload.locale,
        supportedLocales: action.payload.supportedLocales,
        currency: action.payload.currency,
        supportedCurrencies: action.payload.supportedCurrencies,
        user: action.payload.user,
        imageCachePaths: action.payload.imageCachePaths,
        account: action.payload.account,
        accounts: action.payload.accounts,
        header: action.payload.header,
        footer: action.payload.footer,
        privateFilesystemPath: action.payload.privateFilesystemPath,
        mediaBaseUrl: action.payload.mediaBaseUrl,
        shopAdmins: action.payload.shopAdmins,
        isImpersonator: action.payload.isImpersonator,
        isPoolAccount: action.payload.isPoolAccount,
    }));
});
